import EmailsDashboard from "./EmailsDashboard";

export default EmailsDashboard;
